import { Subject } from 'rxjs';
import { Config } from '../../config';
import { Order } from '../../config/order';
import { Product } from '../../config/product';
import { ProductType } from '../../config/product-type';
import { IUpSellChangeEvent, IUpSellEvent, IUpSellQuantityChangeResponse } from '../../config/upsell-response';
import { UpSellProductView } from '../../view/upsell/upsell-product-view';
import { Form } from '../form';
import { FormTypes } from '../form-types';
import { UpSellQuantityForm } from './upsell-quantity-form';

export class UpSellProductForm extends Form {
    private products: Product[] = [];
    quantityForms: UpSellQuantityForm[] = [] as UpSellQuantityForm[];
    view: UpSellProductView = new UpSellProductView();
    currentProduct: any = {};
    type = FormTypes.UpSellProduct;

    upSellProducts: Product[] = [];


    async init(config: Config, callback: any, subject: Subject<IUpSellEvent>) {
        await super.init(config, callback);
        this.parentSubject = subject;
        this.upSellProducts = this.config.widget.data.result.upsell.products;

        if (this.upSellProducts) {

            this.products = this.upSellProducts.filter((product: Product) => {
                return (product.type === ProductType.SINGLE_PAYMENT) && !product.prices && !product.addon;
            });
        }

        this.quantityForms = [];
        this.products.forEach(async prod => {
            if (prod.showQuantity) {
                const quantityChangeSubject = new Subject<IUpSellQuantityChangeResponse>();
                const newQForm = new UpSellQuantityForm(prod.name);
                this.quantityForms.push(newQForm);
                await newQForm.init({}, {}, quantityChangeSubject);

                quantityChangeSubject.subscribe(res => {
                    this.setQuantity(res);
                });
            }
        });

        return Promise.resolve();
    }

    setQuantity(res: IUpSellQuantityChangeResponse) {
        const checkProduct = this.products.find(x => x.name === res.productName);

        if (checkProduct) {
            const amount = (res.quantity > 0 ? res.quantity : 1) * checkProduct.amount;

            if (this.parentSubject) {
                this.parentSubject.next({
                    prodType: 'single_product',
                    evType: IUpSellChangeEvent.QuantityChange,
                    product: checkProduct,
                    quantity: res.quantity > 0 ? res.quantity : 1,
                    prodAmount: amount
                });
            }
        }
    }

    async render() {
        if (this.products.length) {
            this.view.render({
                products: this.products,
                currency: this.config.settings.currency,
                callback: this.onSelectedProductChange.bind(this),
                isOneProduct: this.upSellProducts.length === 1
            });
        }

        this.quantityForms.forEach(qForm => qForm.render());

        return Promise.resolve();
    }

    submit(order: Order) {
        return Promise.resolve(order);
    }

    onSelectedProductChange(product: Product, isChecked: boolean) {
        if (this.parentSubject) {
            const ifQuantityForm = this.quantityForms.find(x => x.productName === product.name);

            this.parentSubject.next({
                prodType: 'single_product',
                evType: IUpSellChangeEvent.SelectChange,
                product: product,
                quantity: ifQuantityForm ? ifQuantityForm.formQuantity : 1,
                isChecked
            });
        }
    }

    private setDiscount(selectedProducts: Array<any>) {
        if (this.config.settings && this.config.settings.discountId) {
            const coupon = this.config.settings.discountId;
            return selectedProducts.map((item: any) => {
                item.discountId = coupon.id;
                return item;
            });
        }
        return selectedProducts;
    }

    setAmountFromUrl(urlAmount: string) {
        const product = this.upSellProducts[0];
        if (product.type === ProductType.SINGLE_PAYMENT) {
            product.amount = Number(urlAmount);
            this.paymentData.amount = Number(urlAmount);
            this.triggerEvent('amountChange');
        }
    }

}
